import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Sliders = createReactComponent("Sliders", ["svg", defaultAttributes, [["line", {
  x1: "4",
  y1: "21",
  x2: "4",
  y2: "14",
  key: "1d0eeh"
}], ["line", {
  x1: "4",
  y1: "10",
  x2: "4",
  y2: "3",
  key: "1lxy4j"
}], ["line", {
  x1: "12",
  y1: "21",
  x2: "12",
  y2: "12",
  key: "lopc1c"
}], ["line", {
  x1: "12",
  y1: "8",
  x2: "12",
  y2: "3",
  key: "6da0nv"
}], ["line", {
  x1: "20",
  y1: "21",
  x2: "20",
  y2: "16",
  key: "1muld8"
}], ["line", {
  x1: "20",
  y1: "12",
  x2: "20",
  y2: "3",
  key: "10tfhs"
}], ["line", {
  x1: "1",
  y1: "14",
  x2: "7",
  y2: "14",
  key: "s98c5y"
}], ["line", {
  x1: "9",
  y1: "8",
  x2: "15",
  y2: "8",
  key: "3q5vsd"
}], ["line", {
  x1: "17",
  y1: "16",
  x2: "23",
  y2: "16",
  key: "1mqi41"
}]]]);
export default Sliders;